import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const TagCategoryApi = createApi({
  reducerPath: "TagCategoryApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    getAllTagCategory: builder.query({
      query: () => {
        return "v1/page_tag_cat";
      },
      keepUnusedDataFor: 0,
      transformResponse: (response) => response.data,
    }),

    mergePageCategory: builder.mutation({
      query: ({ preference, remove }) => {
        const startDate = "2023-01-01";
        const currentDate = new Date().toISOString().split("T")[0];

        return {
          url: "v1/merge_page_category",
          method: "PUT",
          body: {
            preference_id: preference,
            removed_id: remove,
            flag: 2,
            start_date: startDate,
            end_date: currentDate,
          },
        };
      },
    }),

    addTagCategory: builder.mutation({
      query: (payload) => ({
        url: "v1/page_tag_cat",
        method: "POST",
        body: payload,
      }),
    }),
    updateTagCategory: builder.mutation({
      query: (payload) => ({
        url: "v1/page_tag_cat",
        method: "PUT",
        body: payload,
      }),
    }),
    deleteTagCategory: builder.mutation({
      query: (id) => ({
        url: `v1/page_tag_cat/${id}`,
        method: "DELETE",
      }),
    }),

    getAllCatAssignment: builder.query({
      query: () => `v1/get_all_page_cat_assignment`,
      transformResponse: (response) => response.data.data,
      keepUnusedDataFor: 0,
    }),
    mergePageSubCategory: builder.mutation({
      query: ({ preference, remove }) => {
        const startDate = "2023-01-01";
        const currentDate = new Date().toISOString().split("T")[0];

        return {
          url: "v1/merge_page_sub_category",
          method: "PUT",
          body: {
            preference_id: preference,
            removed_id: remove,
            flag: 2,
            start_date: startDate,
            end_date: currentDate,
          },
        };
      },
    }),

    editPageCatAssignment: builder.mutation({
      query: ({ user_id, page_sub_category_id, updated_by }) => ({
        url: "v1/edit_page_cat_assignment",
        method: "POST",
        body: {
          user_id,
          page_sub_category_id,
          updated_by,
        },
      }),
    }),

    getSubCategoriesByCategoryId: builder.query({
      query: (categoryId) => {
        return `v1/get_all_sub_cat_with_cat_id/${categoryId}`;
      },
    }),

    deleteItemById: builder.mutation({
      query: ({ endpoint, id }) => ({
        url: `${endpoint}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetAllTagCategoryQuery,
  useAddTagCategoryMutation,
  useUpdateTagCategoryMutation,
  useDeleteTagCategoryMutation,
  useMergePageCategoryMutation,
  useMergePageSubCategoryMutation,
  useEditPageCatAssignmentMutation,
  useGetSubCategoriesByCategoryIdQuery,
  useDeleteItemByIdMutation,
} = TagCategoryApi;

export default TagCategoryApi;
